import { Routes } from '@angular/router';
import { AccountLayoutPage } from './pages/account/account-layout-page/account-layout-page';
import { AccountOrdersPage } from './pages/account/account-orders-page/account-orders-page';
import { AccountProfilePage } from './pages/account/account-profile-page/account-profile-page';
import { LoginPage } from './pages/auth/login-page/login-page';
import { ResetPasswordPage } from './pages/auth/reset-password-page/reset-password-page';
import { SignupPage } from './pages/auth/signup-page/signup-page';
import { SignupSentPage } from './pages/auth/signup-sent-page/signup-sent-page';
import { SignupVerificationPage } from './pages/auth/signup-verification-page/signup-verification-page';
import { HomePage } from './pages/home-page/home-page';
import { AboutUsPage } from './pages/main/about-us-page/about-us-page';
import { ContactUsPage } from './pages/main/contact-us-page/contact-us-page';
import { MainDrawerPage } from './pages/main/main-drawer-page/main-drawer-page';
import { PrivacyPolicyPage } from './pages/policy/privacy-policy-page/privacy-policy-page';
import { ReturnExchangePolicyPage } from './pages/policy/return-exchange-policy-page/return-exchange-policy-page';
import { TermsOfServicePage } from './pages/policy/terms-of-service-page/terms-of-service-page';
import { ProductCollectionPage } from './pages/product/product-collection-page/product-collection-page';
import { ProductPage } from './pages/product/product-page/product-page';
import { ProductSearchPage } from './pages/product/product-search-page/product-search-page';
import { CheckoutPage } from './pages/shopping/checkout-page/checkout-page';
import { CheckoutResultPage } from './pages/shopping/checkout-result-page/checkout-result-page';
import { ShoppingCartPage } from './pages/shopping/shopping-cart-page/shopping-cart-page';

const noindex = 'noindex, nofollow';

export const routes: Routes = [
  {
    path: '',
    component: MainDrawerPage,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomePage,
        data: {
          seo: {
            canonicalPath: '/',
            description:
              "Shop Lace & Liora, an independent online boutique for romantic lace tops, lace dresses, feminine separates, and effortless women's clothing.",
            image: '/images/home/banner.webp',
            imageAlt: "Lace & Liora romantic lace women's clothing",
            keywords: [
              'Lace & Liora',
              "women's fashion",
              "women's lace clothing",
              'lace tops',
              'lace dresses',
              'romantic tops',
              'boutique clothing',
              'feminine clothing',
              'new arrivals',
            ],
          },
        },
      },
      {
        path: 'about-us',
        pathMatch: 'full',
        component: AboutUsPage,
        data: {
          seo: {
            title: 'About Us',
            canonicalPath: '/about-us',
            description:
              'Learn about Lace & Liora, an independent women-led fashion brand creating romantic lace clothing, wearable pieces, and thoughtful everyday style.',
            image: '/images/about/banner.webp',
            imageAlt: 'About Lace & Liora fashion brand',
          },
        },
      },
      {
        path: 'contact-us',
        pathMatch: 'full',
        component: ContactUsPage,
        data: {
          seo: {
            title: 'Contact Us',
            canonicalPath: '/contact-us',
            description:
              'Contact Lace & Liora for order help, shipping questions, exchange requests, wholesale inquiries, and customer support.',
            image: '/images/contact/contact.webp',
            imageAlt: 'Contact Lace & Liora customer support',
          },
        },
      },
      {
        path: 'privacy-policy',
        pathMatch: 'full',
        component: PrivacyPolicyPage,
        data: {
          seo: {
            title: 'Privacy Policy',
            canonicalPath: '/privacy-policy',
            description:
              'Read the Lace & Liora privacy policy to learn how customer information is collected, used, and protected.',
          },
        },
      },
      // {
      //   path: 'faq',
      //   pathMatch: 'full',
      //   component: FaqPage,
      // },
      {
        path: 'terms-of-service',
        pathMatch: 'full',
        component: TermsOfServicePage,
        data: {
          seo: {
            title: 'Terms of Service',
            canonicalPath: '/terms-of-service',
            description:
              'Review the Lace & Liora terms of service for site use, purchases, account terms, and customer responsibilities.',
          },
        },
      },
      {
        path: 'return-and-exchange-policy',
        pathMatch: 'full',
        component: ReturnExchangePolicyPage,
        data: {
          seo: {
            title: 'Return & Exchange Policy',
            canonicalPath: '/return-and-exchange-policy',
            description:
              'Review the Lace & Liora return and exchange policy, including eligible items, timelines, and support options.',
          },
        },
      },
      {
        path: 'collection/:no',
        pathMatch: 'full',
        component: ProductCollectionPage,
        data: {
          seo: {
            title: 'Collection',
            description:
              "Browse curated Lace & Liora collections featuring new arrivals, best sellers, lace tops, lace dresses, and romantic women's clothing.",
            image: '/images/home/banner.webp',
          },
        },
      },
      {
        path: 'search',
        pathMatch: 'full',
        component: ProductSearchPage,
        data: {
          seo: {
            title: 'Search',
            canonicalPath: '/search',
            description:
              "Search Lace & Liora for women's lace tops, lace dresses, romantic styles, colors, sizes, and new arrivals.",
            robots: 'noindex, follow',
          },
        },
      },
      {
        path: 'product/:no',
        pathMatch: 'full',
        component: ProductPage,
        data: {
          seo: {
            title: 'Product',
            description:
              "Shop Lace & Liora women's clothing product details, fabrics, sizing, delivery estimates, and styling options.",
            type: 'product',
          },
        },
      },
      {
        path: 'shopping/cart',
        pathMatch: 'full',
        component: ShoppingCartPage,
        data: {
          seo: {
            title: 'Shopping Cart',
            canonicalPath: '/shopping/cart',
            robots: noindex,
          },
        },
      },
      {
        path: 'checkout/result',
        pathMatch: 'full',
        component: CheckoutResultPage,
        data: {
          seo: {
            title: 'Payment Confirmation',
            canonicalPath: '/checkout/result',
            robots: noindex,
          },
        },
      },
      {
        path: 'login',
        pathMatch: 'full',
        component: LoginPage,
        data: {
          seo: {
            title: 'Login',
            canonicalPath: '/login',
            robots: noindex,
          },
        },
      },
      {
        path: 'signup',
        pathMatch: 'full',
        component: SignupPage,
        data: {
          seo: {
            title: 'Signup',
            canonicalPath: '/signup',
            robots: noindex,
          },
        },
      },
      {
        path: 'signup/sent',
        pathMatch: 'full',
        component: SignupSentPage,
        data: {
          seo: {
            title: 'Please Verify Your Email',
            canonicalPath: '/signup/sent',
            robots: noindex,
          },
        },
      },
      {
        path: 'signup/verification',
        pathMatch: 'full',
        component: SignupVerificationPage,
        data: {
          seo: {
            title: 'Email Verification',
            canonicalPath: '/signup/verification',
            robots: noindex,
          },
        },
      },
      {
        path: 'reset-password',
        pathMatch: 'full',
        component: ResetPasswordPage,
        data: {
          seo: {
            title: 'Reset Password',
            canonicalPath: '/reset-password',
            robots: noindex,
          },
        },
      },
    ],
  },
  {
    path: 'checkout/:id',
    pathMatch: 'full',
    component: CheckoutPage,
    data: {
      seo: {
        title: 'Checkout',
        canonicalPath: '/checkout',
        robots: noindex,
      },
    },
  },
  {
    path: 'account',
    component: AccountLayoutPage,
    data: {
      seo: {
        title: 'Account',
        canonicalPath: '/account',
        robots: noindex,
      },
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profile',
      },
      {
        path: 'profile',
        pathMatch: 'full',
        component: AccountProfilePage,
        data: {
          seo: {
            title: 'Account Profile',
            canonicalPath: '/account/profile',
            robots: noindex,
          },
        },
      },
      {
        path: 'orders',
        pathMatch: 'full',
        component: AccountOrdersPage,
        data: {
          seo: {
            title: 'My Orders',
            canonicalPath: '/account/orders',
            robots: noindex,
          },
        },
      },
    ],
  },
];
